var _path, _path2, _ellipse, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 206,
    viewBox: "0 0 206 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.156 79.135C189.611 101.088 173.209 137.4 138.521 160.239C103.833 183.078 63.9955 183.796 49.541 161.843C35.0864 139.89 51.4886 103.578 86.1764 80.7388C120.864 57.8997 160.702 57.1816 175.156 79.135Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.933 142.57C94.2454 165.409 54.4077 166.127 39.9531 144.173L49.5352 161.843C63.9897 183.797 103.827 183.079 138.515 160.239L138.515 160.239C173.203 137.4 189.605 101.089 175.151 79.1354L168.064 66.0669C167.368 64.4741 166.538 62.9375 165.569 61.4654L168.064 66.0669C177.741 88.2279 161.295 121.262 128.933 142.569L128.933 142.57Z",
    fill: "url(#paint0_linear_1339_22689)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.761,
    cy: 102.818,
    rx: 75.1995,
    ry: 47.5926,
    transform: "rotate(-33.3618 102.761 102.818)",
    fill: "url(#paint1_linear_1339_22689)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5898 63.0703C41.902 85.9095 25.4998 122.221 39.9543 144.174L47.0411 157.243C47.7367 158.836 48.5672 160.372 49.5364 161.844L47.0411 157.243C37.3637 135.082 53.81 102.048 86.1718 80.7404C120.86 57.9012 160.697 57.1832 175.152 79.1365L165.57 61.4666C151.115 39.5132 111.278 40.2312 76.5898 63.0703Z",
    fill: "#7551FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9547 144.173C25.5001 122.22 41.9024 85.9084 76.5902 63.0692C111.278 40.2301 151.116 39.5121 165.57 61.4654L175.152 79.1354C160.698 57.182 120.86 57.9001 86.1722 80.7393C61.3952 97.053 45.9476 120.24 44.4107 140.159C45.9476 120.24 61.3953 97.053 86.1722 80.7394C120.86 57.9002 160.698 57.1821 175.152 79.1354C189.607 101.089 173.205 137.4 138.517 160.24C103.829 183.079 63.9913 183.797 49.5368 161.843C48.5673 160.371 47.7367 158.834 47.041 157.241L39.9547 144.173Z",
    fill: "#7551FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.29
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M151.674 69.571C163.152 87.0788 150.09 116.062 122.498 134.306C94.9063 152.551 63.2337 153.148 51.7554 135.64C40.277 118.133 53.3395 89.1497 80.9312 70.9052C108.523 52.6606 140.195 52.0633 151.674 69.571Z",
    fill: "#7551FF",
    fillOpacity: 0.77
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1339_22689",
    x1: 66.1805,
    y1: 175.253,
    x2: 174.618,
    y2: 130.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7551FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1339_22689",
    x1: 27.5618,
    y1: 102.818,
    x2: 177.961,
    y2: 102.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#BA9AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#977EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin1);
export default __webpack_public_path__ + "static/media/Coin1.0f5293f8974fa612f4ba1ae48dcc5b71.svg";
export { ForwardRef as ReactComponent };